export default function Logo({white=false, width=350, height=150, classNameIn}) {
    return (
        <>
            {white && <img
                height={height} width={width}
                className={classNameIn ? classNameIn : "py-4 px-2"}
                src="/img/cromate-logo-dark.png"
                alt="Mermaid Devs"
            />}
            {!white && <img
                height={height} width={width}
                className={classNameIn ? classNameIn : "py-4 px-2"}
                src="/img/cromate-logo.png"
                alt="Mermaid Devs" />}
        </>
    )
}

export function LogoAI({white=false, width=292, height=135, classNameIn}) {
    return (
        <>
            {white && <img
                height={height} width={width}
                className={classNameIn ? classNameIn : "py-4"}
                src="/img/cromate-logo-dark.png"
                alt="Mermaid Devs" />}
            {!white && <img
                height={height} width={width}
                className={classNameIn ? classNameIn : "py-4"}
                src="/img/cromate-logo.png"
                alt="Mermaid Devs" />}
        </>
    )
}
